import Flickity from 'flickity'
import 'flickity-fade'
import 'flickity/dist/flickity.css'
import 'flickity-fade/flickity-fade.css'

const ARROW_SHAPE = 'M52.806 98.977a3.52 3.52 0 0 0 0-4.996L8.497 50.048 52.806 6.03a3.52 3.52 0 0 0 0-4.996 3.575 3.575 0 0 0-5.03 0L1.042 47.464A3.439 3.439 0 0 0 0 49.962c0 .862.347 1.81 1.04 2.498l46.737 46.43a3.5 3.5 0 0 0 5.029.087z'

const SLIDER_DEFAULTS = {
  autoPlay: 6000,
  adaptiveHeight: false,
  pauseAutoPlayOnHover: false,
  cellAlign: 'left',
  groupCells: '100%',
  wrapAround: true,
  arrowShape: ARROW_SHAPE,
  draggable: false
}

export function setupSlider($el, _opts) {
  const opts = Object.assign({}, SLIDER_DEFAULTS, _opts)

  if (opts.prevNextButtons !== false) {
    $el.classList.add('has-buttons')
  }

  if ($el.children.length) {
    $el.classList.add('is-single-slide')
  }

  $el.classList.add('is-init')
  $el.offsetHeight

  const slider = new Flickity($el, opts)

  slider.on('resize', function () {
    const isSingleSlide = this.slides.length < 2
    const hasPrevNextButtons = this.options.prevNextButtons

    this.element.classList.toggle('is-single-slide', isSingleSlide)
    this.element.classList.toggle('has-buttons', hasPrevNextButtons)
  })

  slider.resize()

  return slider
}
